// @ts-expect-error - no type definition
import {WebGL} from "three/examples/jsm/Addons";

export const WEBGL_SUPPORTED = WebGL.isWebGLAvailable()
